import React from 'react';
import { injectIntl } from 'react-intl';
import NavigationBar from './navigation-bar';
import Footer from './footer';
import AssetDetailsDropdown from '../svod/asset-details-dropdown';
import ThumbnailItem from './thumbnail-item';
import SVODSideMenu from './SVODSideMenu';
import { connect } from 'react-redux';
import { updateWatchlist } from '../../redux/actions/SVOD';
import svodMessages from '../../locales/svod';
import { EnvType } from "./constants";

class Watchlist extends React.Component {
	constructor(props) {
		super(props);
		this.videoRows = this.props.videoRows;
		this.state = {
			videos: this.props.watchlist
		};
	}

	componentDidMount() {
		this.props.eventHandler({
			data: { event_type: "time_interacted_with", type: "watchlist", action: "start_time", time: Date.now() }
		});
	}

	componentWillUnmount() {
		this.props.eventHandler({
			data: { event_type: "time_interacted_with", type: "watchlist", action: "end_time", time: Date.now() }
		});
	}

	render() {
		const watchlistItems = (this.state.videos.length > 0) ? (
			this.state.videos.map((videoID, idx) => {
				for (let i = 0; i < this.videoRows.length; i++) {
					if (videoID in this.videoRows[i]) {
						return <ThumbnailItem watchlist_video={true} eventHandler={this.props.eventHandler} video={this.videoRows[i][videoID]} label={"watchlist"} idx={idx} page_location="watch_list_page" key={`watchlist-index`} />;
					}
				}
			})
		) : (
			<p>{this.props.intl.formatMessage(svodMessages.no_items_added)}</p>
		);

		let itemShow = (this.props.dropdown.video === undefined) ? (
			<span></span>
		) : (
			<AssetDetailsDropdown {...this.props} />
		);

		return (
			<div className="svod-page">
				<div id="top"></div>

				{this.props.environment === EnvType.PEACOCK
					? <SVODSideMenu {...this.props} page="watchlist" />
					: <NavigationBar {...this.props} page="watchlist" />
				}

				<div className="video-index">
					<h1 className="favorites-header">{this.props.intl.formatMessage(svodMessages.my_list)}</h1>
					<div className="category-list favorites">
						{watchlistItems}
					</div>
					<span>
						{itemShow}
					</span>
				</div>

				<Footer />
			</div>
		);
	}
}


const mapStateToProps = (state) => ({
	watchlist: state.SVOD.watchlist,
	videoRows: Object.values(state.SVOD.videos),
	dropdown: state.SVOD.dropdown,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	eventHandler: ownProps.eventHandler,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Watchlist));


// WEBPACK FOOTER //
// ./src/components/svod/watch-list.jsx